import { useCallback } from "react";
import {
  fetchCityStateByZip,
  patchGuardianAddressRow,
} from "../guardianAddressHandlers";

/** Address auto-complete + ZIP → city/state for principal rows. */
export function useBondPrincipalAddressHandlers({ cfg, keys, data, updateData, dataRef }) {
  const handleGoogleCallback = useCallback(
    (index, address, city, state, zipCode) => {
      const currentData = dataRef.current;
      const guardians = patchGuardianAddressRow(currentData.guardians, index, keys, {
        [keys.address]: address,
        [keys.city]: city,
        [keys.state]: state,
        [keys.zip]: zipCode,
      });
      updateData({ ...currentData, guardians });
    },
    [dataRef, keys, updateData]
  );

  const handleZipCodeChange = useCallback(
    async (e, index) => {
      const zipCode = e.target.value;
      const guardians = patchGuardianAddressRow(data.guardians, index, keys, {
        [keys.zip]: zipCode,
      });
      updateData({ ...data, guardians });

      if (zipCode.length !== 5) return;

      try {
        const location = await fetchCityStateByZip(zipCode, cfg.zipLookup);
        if (!location) return;
        const currentData = dataRef.current;
        const freshGuardians = patchGuardianAddressRow(
          currentData.guardians,
          index,
          keys,
          {
            [keys.city]: location.city,
            [keys.state]: location.state,
            [keys.zip]: zipCode,
          }
        );
        updateData({ ...currentData, guardians: freshGuardians });
      } catch (error) {
        console.error("Error fetching city/state by zip code:", error);
      }
    },
    [cfg.zipLookup, data, dataRef, keys, updateData]
  );

  return { handleGoogleCallback, handleZipCodeChange };
}
